import { useEffect, useRef } from "react";

export function Confetti() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const colours = [
      "#C9184A", "#FF6B9D", "#FFD9A8",
      "#D4ECD4", "#5B45D4", "#FFE066", "#1DB954"
    ];

    const pieces = Array.from({ length: 120 }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * -canvas.height,
      w: Math.random() * 12 + 6,
      h: Math.random() * 6 + 4,
      colour: colours[Math.floor(Math.random() * colours.length)],
      rotation: Math.random() * 360,
      speed: Math.random() * 3 + 2,
      rotSpeed: Math.random() * 4 - 2,
      swing: Math.random() * 3,
      swingSpeed: Math.random() * 0.05,
      swingOffset: Math.random() * Math.PI * 2,
    }));

    let frame = 0;
    let animId: number;

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      frame++;

      pieces.forEach(p => {
        p.y += p.speed;
        p.rotation += p.rotSpeed;
        p.x += Math.sin(p.swingOffset + frame * p.swingSpeed) * p.swing;
        if (p.y > canvas.height) p.y = -20;

        ctx.save();
        ctx.translate(p.x + p.w / 2, p.y + p.h / 2);
        ctx.rotate(p.rotation * Math.PI / 180);
        ctx.fillStyle = p.colour;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });

      animId = requestAnimationFrame(draw);
    };

    draw();
    return () => cancelAnimationFrame(animId);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: 999,
      }}
    />
  );
}
